export class Game {
    id: string = ""
    name: GameTextData[] = []
    description: GameTextData[] = []
    details: GameTextData[] = []
    published: boolean = false
    isHero: boolean = false
    image: GameTextData[] = []
    hero?: HeroBlock
    texts?: GameText[] = []
    players?: GameTextData[] = []
    duration?: GameTextData[] = []
    age?: GameTextData[] = []
    series?: GameRelation[] = []
    addons?: GameRelation[] = []
    downloads?: Attachment[] = []
    gallery?: Attachment[] = []
}

export class Attachment{
    name: GameTextData[] = []
    description: GameTextData[] = []
    file: GameTextData[] = []
    standalone: boolean = false
}

export class GameRelation{
    name: GameTextData[] = []
    description: GameTextData[] = []
    image: GameTextData[] = []
    link: GameTextData[] = []
}

export class HeroBlock{
    background: GameTextData[] = []
    image: GameTextData[] = []
    buttons: ButtonConfig[] = []
}

export class ButtonConfig{
    type: 'primary' | 'secondary' = 'primary'
    text: GameTextData[] = []
    link: GameTextData[] = []
}

export class GameText{
    key: string = ""
    data: GameTextData[] = []
}

export class GameTextData{
    lang: string = ""
    text: string = ""
}

export const getTextByLang = (data: GameTextData[] | undefined, lang: string): string => {
    if (!data) return "";
    const requested = data.find(d => d.lang === lang);
    if (requested?.text) return requested.text;
    const en = data.find(d => d.lang === "en");
    if (en?.text) return en.text;
    return data.find(d => d.text)?.text ?? "";
}